export interface RecetaCarouselItem {
  id: number;
  src: string;
  alt: string;
}

export const recetasCarousel: RecetaCarouselItem[] = [
  {
    id: 1,
    src: 'https://cdn.magicpatterns.com/uploads/gUjtT9753dyYwHBCHCQhy4/Diseno_sin_titulo_(6).webp',
    alt: 'Receta 03: Pechuga de pollo al curry y coco, y receta 35: pechuga con salsa de champiñones'
  },
  {
    id: 2,
    src: 'https://cdn.magicpatterns.com/uploads/r82rauLj9fthytv8sGeSsF/Diseno_sin_titulo_(5).webp',
    alt: 'Receta de mousse de chocolate negro y aguacate, y receta de flan de coco sin azúcar'
  },
  {
    id: 3,
    src: 'https://cdn.magicpatterns.com/uploads/6KeScsHkqKTvQFYHoNPsX9/Diseno_sin_titulo_(9).webp',
    alt: 'Receta 28: smoothie de coco y frutos del bosque, y receta 11: pudding de chía y lima'
  },
  {
    id: 4,
    src: 'https://cdn.magicpatterns.com/uploads/5k1frv6wwaFu16xb282CJZ/Diseno_sin_titulo_(8).webp',
    alt: 'Receta 27: canelones de calabacín y requesón, y receta 16: sopa de verduras y pollo desmenuzado'
  },
  {
    id: 5,
    src: 'https://cdn.magicpatterns.com/uploads/m5YxoJJSuCckYmT9BZDeQp/Diseno_sin_titulo_(7).webp',
    alt: 'Receta 26: bacalao al horno con tomate y aceitunas, y receta 01: salmón al papillote con cítricos'
  }
];
